import React from 'react';
import AdminDataTable from './AdminDataTable';

/**
 * Configuration pour l'administration des appels IA
 */
const iaCallsConfig = {
  entityName: 'ia_calls',
  apiEndpoint: '/api/config/tool/ia-calls',
  exportFileName: 'ia-calls',
  
  translations: {
    title: 'IA_CALLS_TITLE'
  },
  
  columns: [
    { key: 'id', label: 'ID', labelKey: 'TABLE_ID' },
    { key: 'call_key', label: 'Clé', labelKey: 'TABLE_CALL_KEY' },
    { 
      key: 'ia_language', 
      label: 'Langue', 
      labelKey: 'TABLE_LANGUAGE',
      type: 'dynamic-select',
      dynamicSource: 'ia_language'
    },
    { 
      key: 'usage_type', 
      label: 'Type usage', 
      labelKey: 'TABLE_USAGE_TYPE',
      type: 'dynamic-select',
      dynamicSource: 'usage_type'
    },
    { 
      key: 'ai_type', 
      label: 'Type IA', 
      labelKey: 'TABLE_AI_TYPE',
      type: 'dynamic-select',
      dynamicSource: 'ai_type'
    },
    { 
      key: 'use_canon', 
      label: 'Utilise Canon', 
      labelKey: 'TABLE_USE_CANON',
      type: 'booleanTag'
    },
    { 
      key: 'data_format', 
      label: 'Format', 
      labelKey: 'TABLE_DATA_FORMAT',
      type: 'dynamic-select',
      dynamicSource: 'data_format'
    },
    { 
      key: 'is_active', 
      label: 'Actif', 
      labelKey: 'TABLE_IS_ACTIVE',
      type: 'booleanTag'
    },
    { key: 'temperature', label: 'Température', labelKey: 'TABLE_TEMPERATURE' }
  ],
  
  formFields: [
    {
      name: 'call_key',
      label: 'Clé de l\'appel',
      labelKey: 'FORM_CALL_KEY',
      type: 'text',
      required: true,
      placeholder: 'DescribePortrait, CanonTemplate...'
    },
    {
      name: 'ia_language',
      label: 'Langue',
      labelKey: 'FORM_IA_LANGUAGE',
      type: 'dynamic-select',
      required: true,
      dynamicSource: 'ia_language'
    },
    {
      name: 'usage_type',
      label: 'Type d\'usage',
      labelKey: 'FORM_USAGE_TYPE',
      type: 'dynamic-select',
      required: true,
      dynamicSource: 'usage_type'
    },
    {
      name: 'ai_type',
      label: 'Type d\'IA',
      labelKey: 'FORM_AI_TYPE',
      type: 'dynamic-select',
      required: true,
      dynamicSource: 'ai_type'
    },
    {
      name: 'use_canon',
      label: 'Utilise le canon',
      labelKey: 'FORM_USE_CANON',
      type: 'booleanTag'
    },
    {
      name: 'data_format',
      label: 'Format de données',
      labelKey: 'FORM_DATA_FORMAT',
      type: 'dynamic-select',
      dynamicSource: 'data_format'
    },
    {
      name: 'system_prompt',
      label: 'Prompt système',
      labelKey: 'FORM_SYSTEM_PROMPT',
      type: 'textarea',
      placeholder: 'Prompt pour le système IA...'
    },
    {
      name: 'assistant_prompt',
      label: 'Prompt assistant',
      labelKey: 'FORM_ASSISTANT_PROMPT',
      type: 'textarea',
      placeholder: 'Prompt pour l\'assistant...'
    },
    {
      name: 'user_prompt',
      label: 'Prompt utilisateur',
      labelKey: 'FORM_USER_PROMPT',
      type: 'textarea',
      placeholder: 'Prompt pour l\'utilisateur...'
    },
    {
      name: 'temperature',
      label: 'Température',
      labelKey: 'FORM_TEMPERATURE',
      type: 'number',
      step: 0.1,
      min: 0,
      max: 2,
      placeholder: '0.7'
    },
    {
      name: 'is_active',
      label: 'Actif',
      labelKey: 'FORM_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  filters: [
    {
      name: 'call_key',
      label: 'Clé',
      labelKey: 'FILTER_CALL_KEY',
      type: 'text',
      placeholder: 'Rechercher par clé...'
    },
    {
      name: 'ia_language',
      label: 'Langue',
      labelKey: 'FILTER_IA_LANGUAGE',
      type: 'dynamic-select',
      dynamicSource: 'ia_language'
    },
    {
      name: 'usage_type',
      label: 'Type usage',
      labelKey: 'FILTER_USAGE_TYPE',
      type: 'dynamic-select',
      dynamicSource: 'usage_type'
    },
    {
      name: 'ai_type',
      label: 'Type IA',
      labelKey: 'FILTER_AI_TYPE',
      type: 'dynamic-select',
      dynamicSource: 'ai_type'
    },
    {
      name: 'is_active',
      label: 'Statut',
      labelKey: 'FILTER_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  defaultFormData: {
    call_key: '',
    ia_language: 'FR',
    usage_type: 'Handlebarhelper',
    ai_type: 'text',
    use_canon: false,
    data_format: 'text',
    system_prompt: '',
    assistant_prompt: '',
    user_prompt: '',
    temperature: 0.7,
    is_active: true
  }
};

/**
 * Composant d'administration des appels IA
 */
export default function AdminIaCallsTab() {
  return (
    <AdminDataTable {...iaCallsConfig} />
  );
}
